import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validation } from "./helpers/validation";
import {
  TextField,
  Button,
  Typography,
  Box,
  Link,
  Grid,
  Avatar,
  Container,
  CircularProgress,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { ClienteFormContext } from "../../../context/cliente/ClienteContext";

export const Form = () => {
  const { forgotPassword } = useContext(ClienteFormContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validation),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const formData = { cli_mail: data.cli_email };
    try {
      const result = await forgotPassword(formData); 
      const severity = result?.status === 200 ? "success" : "error";
      const message =
        result?.mensaje || result?.data?.mensaje || "Error inesperado";
       navigate("/password-reset-result", { state: { severity, message } });
    } catch (err) {
      navigate("/password-reset-result", {
        state: {
          severity: "error",
          message:
            "Ocurrió un error de red. Por favor, intentá nuevamente más tarde.",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          bgcolor: "background.paper",
          p: 3,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <AccountCircleIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Recuperar contraseña
        </Typography>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email*"
              {...register("cli_email")}
              error={!!errors.cli_email}
              helperText={errors.cli_email?.message}
            />
          </Grid>
        </Grid>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={!isValid || loading}
          sx={{ mt: 3, mb: 2, position: "relative" }}
        >
          {loading ? (
            <CircularProgress size={24} sx={{
              color: "common.white",
            }}/>
          ) : (
            "Enviar"
          )}
        </Button>

        <Typography variant="body2" align="center">
          ¿Ya tenés cuenta? Iniciá sesión{" "}
          <Link href="login" underline="hover">
            aquí
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};
